module.exports = __webpack_public_path__ + "img/RYAZ.dfdda122.png";